module.exports = __webpack_public_path__ + "assets/img/infoItem03.54de0be8.png";